export default {

    // NEW
    token: {
        id: 0,
        owner: null,
        name: null,
        symbol: null,           
        contract: null,
        imageUrl: null,
        websiteUrl: null,
        description: null   
    },
    tokens: [],
    contract: null,
    contractTokens: [],
    registeredTokens: 0,
    contractDetails: null,

    // Cards
    card: {},
    cards: [],
    allCards: [],
    cardsCreated: 0,
    selectedCards: [],
    cardLoading: false,
    cardCounterLoading: false,
    
    // Battle
    battle: {},
    battles: [],
    filteredBattles: [],
    battleResults: {},
    battleFilters: {
        status: 'all',
        score: 'all',
        onlyMe: false
    },
    battleLoading: false,
    openBattleIds: [],

    // Auctions
    auctions: [],
    auctionLoading: false,

    // Users
    user: {
        address: null,
        lossCount: 0,
        winCount: 0,
        tokens: 0
    },
    users: [],
    account: null,
    userLoading: false,
    
    // User interface
    modalType: '',
    loading: true,
    hasExtension: true,
    pendingTransaction: false,
    hasError: {
        status: false,
        message: null
    },
    locale: 'en'

};


// WEBPACK FOOTER //
// ./src/store/state.js